'use client';

import { Box, Typography } from '@mui/material';
import { CreateListingType } from '@/schemas/CreateListingSchema';
import {
  ibow2_proto_PortalOfficeListing,
  service_ResponseForNonMemberPortalOfficeListing,
} from '@/init/swagger';
import { parseImportantDocuments } from '@/helpers/importantDocumentHelper';
import { ImportantDocumentThumbnail } from '@/features/importantDocument/ImportantDocumentThumbnail';
import { useLogic } from './logic';
import { OpenLinkIcon } from '@/features/icon/OpenLinkIcon';
import { DocumentTextBox } from './DocumentTextBox';
import { useEffect, useState } from 'react';

type Props = {
  listingDetail:
    | CreateListingType['portal_office_listing']
    | ibow2_proto_PortalOfficeListing
    | service_ResponseForNonMemberPortalOfficeListing;
};

export function ImportantDocumentsSection({ listingDetail }: Props) {
  const importantDocuments = parseImportantDocuments(
    listingDetail.portal_office_listing_important_documents,
  );
  const { isMobile } = useLogic();

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  if (importantDocuments.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
      id="important-documents-section"
    >
      <Typography
        variant={
          isMobile ? 'JP/Heading/s/Bold/Tight' : 'JP/Heading/m/Bold/Tight'
        }
      >
        重要事項および各種書類 等
      </Typography>

      <Typography
        variant={isMobile ? 'JP/Body/s/Regular/None' : 'JP/Body/m/Regular/None'}
        sx={{
          color: 'primary.main',
          fontSize: '14px',
        }}
      >
        ファイルの内容および安全性についてご注意の上、閲覧・ダウンロードしてください。
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {importantDocuments.map((document, index) => (
          <Box
            key={index}
            sx={{
              backgroundColor: '#F5FAF9',
              borderRadius: 1,
            }}
          >
            {document.document_type === 'file' && (
              <Box
                sx={{
                  py: 2,
                  px: 2,

                  display: 'flex',
                  gap: 2,
                  justifyContent: 'space-between',
                  alignItems: 'center',

                  cursor: 'pointer',
                }}
                onClick={() =>
                  window.open(
                    document.file_url,
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    alignItems: 'center',
                  }}
                >
                  <Typography>
                    <ImportantDocumentThumbnail
                      fileType={document.file_type || ''}
                      fileUrl={document.file_url || ''}
                    />
                  </Typography>

                  <Typography
                    typography="JP/Body/m/Medium/Normal"
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    {document.file_name}
                  </Typography>
                </Box>

                <OpenLinkIcon width={20} height={20} />
              </Box>
            )}
            {document.document_type === 'text' && (
              <Box
                sx={{
                  py: 2,
                  px: 2,

                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                <Typography
                  typography="JP/Body/m/Medium/Normal"
                  sx={{
                    fontWeight: 700,
                  }}
                >
                  {document.file_name}
                </Typography>

                <DocumentTextBox text={document.document_text || ''} />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
